// extracted by mini-css-extract-plugin
module.exports = {"icon--secondary":"styles_icon--secondary__TwWXM","icon":"styles_icon__SlF_7","skeleton-animation":"styles_skeleton-animation__XEzCB"};